import React from "react";
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import SignIn from "views/auth/SignIn";
import {
  MdHome,
  MdBarChart,
  MdPerson,
  MdLock,
} from "react-icons/md";
import ForgotPassword from "views/auth/ForgotPassword";
import VerifyOTP from "views/auth/verifyOtp";
import UpdateForgotPassword from "views/auth/updateforgotpassword";
import CustomerManagement from "views/admin/customer table";
import RoleManagement from "views/admin/roleMangement";
import BillingTables from "views/admin/billing Module";



const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  
  {
     name: "Role Management",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "role-management",
    component: <RoleManagement/>
  },
  {
    name: "Project Management",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "project-management",
    component: <DataTables />,
  },
  {
    name: "Customer Management",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "customer-management",
    component: <CustomerManagement />,
  },
  {
    name: "Billing Management",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "billing-management",
    component: <BillingTables />,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassword/>,
  },
  {
    name: "Verify Otp",
    layout: "/auth",
    path: "verify-otp",
    icon: <MdLock className="h-6 w-6" />,
    component: <VerifyOTP/>,
  },
 {
    name: "Update Forgot Password",
    layout: "/auth",
    path: "update-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <UpdateForgotPassword/>,
  },

 
];
export default routes;
